<template>
  <multiselect 
    :options="automations.data" 
    :custom-label="({ id, type, threshold, condition, name }) => { 
      if (name) {
        return name
      }
      let label = `(${id}) ${automationTypes[type].name}`
      if (automationTypes[type].threshold(threshold)) {
        label = label + ' / ' + automationTypes[type].threshold(threshold)
      }
      if (automationTypes[type].condition(condition)) {
        label = label + ' / ' + automationTypes[type].condition(condition)
      }
      return label
    }" 
    track-by="id" 
    :value="selected" 
    placeholder="Select Automation"
    @input="handleInput" 
    @remove="handleRemove">
    <template slot="option" slot-scope="props">
      <div class="max-w-full truncate">
        <template v-if="props.option.name">
          <div>
            {{ props.option.name }}
          </div>
          <div class="mt-1 text-sm text-gray-500">
            {{ automationTypes[props.option.type].name }}
          </div>
        </template>
        <template v-else>
          <div>
            {{ automationTypes[props.option.type].name }}
          </div>
          <div class="mt-1 text-sm text-gray-500">
            <span v-if="automationTypes[props.option.type].threshold(props.option.threshold)">
              {{ automationTypes[props.option.type].threshold(props.option.threshold) }}
            </span>
            <span v-if="automationTypes[props.option.type].condition(props.option.condition)">
              {{ automationTypes[props.option.type].condition(props.option.condition) }}
            </span>
          </div>
        </template>
      </div>
    </template>
  </multiselect>
</template>

<script>
import { mapState } from 'vuex'
import Multiselect from 'vue-multiselect'

export default {
  name: 'AutomationSelect',

  components: {
    Multiselect
  },

  created () {
    this.getAutomations()
  },

  props: ['value'],

  computed: {
    ...mapState(['automationTypes']),

    selected () {
      return this.automations.data.find(automation => automation.id === this.value)
    }
  },

  data () {
    return {
      automations: {
        data: []
      }
    }
  },

  methods: {
    async getAutomations () {
      try {
        const { data } = await this.$api.get(`account/${this.$route.params.account}/automations`, {
          params: {
            page: 1,
            sort: 'type',
            dir: 'asc'
          }
        })
        this.automations = data.automations
        this.loading = false
      } catch (error) {
        console.error(error)
      }
    },

    handleInput (value) {
      this.$emit('input', value.id)
    },

    handleRemove () {
      this.$emit('input', null)
    }
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>